"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _AbstractRating = _interopRequireDefault(require("./AbstractRating"));

var Rating = function Rating(props) {
  return _react.default.createElement(_AbstractRating.default, (0, _extends2.default)({
    disabled: true,
    iconSize: props.use === 'card' ? 'xs' : props.iconSize
  }, props));
};

Rating.propTypes = (0, _extends2.default)({}, _AbstractRating.default.propTypes);
Rating.defaultProps = {
  rating: 3
};
var _default = Rating;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/Rating.js
// module id = 87
// module chunks = 209 210 211 212